import { SCORE } from '@/config/constants';

export function comboMultiplier(combo: number): number {
  return Math.min(1 + combo * SCORE.comboStep, SCORE.comboMax);
}

export function scoreForHit(combo: number, remainingMs: number, totalMs: number): number {
  const speedBonus = totalMs > 0 ? Math.max(0, Math.min(SCORE.speedBonusMax, remainingMs / totalMs)) : 0;
  const mult = comboMultiplier(combo);
  return Math.round(SCORE.base * mult * (1 + speedBonus));
}
